import { render, staticRenderFns } from "./ProductCommentsList.vue?vue&type=template&id=6c0d0f20"
import script from "./ProductCommentsList.vue?vue&type=script&lang=js"
export * from "./ProductCommentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports